import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Lock, Mail, User as UserIcon } from "lucide-react";
import { roleHomePath } from "../lib/roleHomePath";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState(() => localStorage.getItem("remembered_email") || "");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(() => !!localStorage.getItem("remembered_email"));
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  if (user && user !== false) {
    return <Navigate to={roleHomePath(user)} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const u = await login(email, password);
      if (remember) {
        localStorage.setItem("remembered_email", email);
      } else {
        localStorage.removeItem("remembered_email");
      }
      toast.success("Login berhasil");
      navigate(roleHomePath(u));
    } catch (e) {
      const msg = formatApiError(e.response?.data?.detail) || e.message;
      setErr(msg);
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(180deg, #5b7da3 0%, #2c4763 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        fontFamily: "Segoe UI, Tahoma, sans-serif",
      }}
    >
      <div className="vb-window" style={{ width: 420, marginBottom: 0 }} data-testid="login-window">
        <div className="vb-titlebar">
          <span className="flex items-center gap-2">
            <UserIcon className="w-3 h-3" /> Sign In - SIMAK
          </span>
        </div>
        <div className="vb-content" style={{ padding: 24 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12, paddingBottom: 10, borderBottom: "1px solid #ddd" }}>
            <img src="/logo-fivehoster.png" alt="logo" style={{ width: 48, height: 48, borderRadius: 4 }} />
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#003399", lineHeight: 1.1 }}>SIMAK</div>
              <div style={{ fontSize: 11, color: "#555" }}>Sistem Management Karyawan</div>
              <div style={{ fontSize: 10, color: "#888" }}>PT. Fivehoster Karya Bangsa</div>
            </div>
          </div>
          <h1 className="vb-h1" style={{ marginBottom: 12 }}>Selamat Datang</h1>
          <p style={{ fontSize: 12, color: "#555", marginBottom: 16 }}>
            Silakan masuk dengan akun Anda
          </p>

          <form onSubmit={submit}>
            <div className="vb-form-row">
              <label className="vb-label">Email</label>
              <div style={{ display: "flex", alignItems: "center", border: "1px solid #828790", borderTopColor: "#404040", borderLeftColor: "#404040", background: "white" }}>
                <Mail className="w-4 h-4" style={{ marginLeft: 8, color: "#666" }} />
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@example.com"
                  className="vb-input"
                  style={{ border: "none" }}
                  data-testid="login-email"
                />
              </div>
            </div>

            <div className="vb-form-row">
              <label className="vb-label">Password</label>
              <div style={{ display: "flex", alignItems: "center", border: "1px solid #828790", borderTopColor: "#404040", borderLeftColor: "#404040", background: "white" }}>
                <Lock className="w-4 h-4" style={{ marginLeft: 8, color: "#666" }} />
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="password123"
                  className="vb-input"
                  style={{ border: "none" }}
                  data-testid="login-password"
                />
              </div>
            </div>

            {err && (
              <div
                style={{
                  background: "#ffbaba",
                  border: "1px solid #d8000c",
                  color: "#d8000c",
                  padding: "6px 8px",
                  fontSize: 12,
                  marginBottom: 8,
                }}
                data-testid="login-error"
              >
                {err}
              </div>
            )}

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 12 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, cursor: "pointer", userSelect: "none" }}>
                <input
                  type="checkbox"
                  checked={remember}
                  onChange={(e) => setRemember(e.target.checked)}
                  data-testid="login-remember"
                  style={{ cursor: "pointer" }}
                />
                Ingat saya
              </label>
              <button
                type="submit"
                className="vb-btn-primary"
                disabled={busy}
                data-testid="login-submit"
              >
                {busy ? "Memproses..." : "Sign In"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
